import './BlobAnimation.scss'

export default function BlobAnimation() {
  return (
    <div className='blob-animation-body'>
      {/* BACKGROUND BLOBS */}
      <div className='bc-blobs'></div>

      {/* LIGHT GREEN BLOBS */}
      <div className='light-green light-green-bg'></div>
      <div className='light-green light-green-md'></div>
      <div className='light-green light-green-md bottom'></div>
      <div className='light-green light-green-sm'></div>

      {/* MEDIUM GREEN BLOBS */}
      <div className='medium-green medium-green-sm middle'></div>
      <div className='medium-green medium-green-sm left'></div>
      <div className='medium-green medium-green-md'></div>

      {/* DARK GREEN BLOBS */}
      <div className='dark-green dark-green-left'></div>
      <div className='dark-green dark-green-right'></div>

      {/* GREEN BLOBS */}
      <div className='green green-left'></div>
      <div className='green green-right'></div>
      <div className='green green-bottom'></div>
    </div>
  )
}
